import { render } from "./MenuTopCmpV2.vue?vue&type=template&id=f37f7196"
import script from "./MenuTopCmpV2.vue?vue&type=script&lang=js"
export * from "./MenuTopCmpV2.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__